import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const Active = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M2.512 7.53l-0.912 1.123 0.202 0.25 2.944 3.651c1.51 1.869 2.749 3.421 2.749 3.446s-1.238 1.578-2.749 3.446l-3.146 3.901 0.912 1.123 0.909 1.123 0.147-0.17c0.080-0.093 1.83-2.253 3.891-4.797l3.744-4.627-3.744-4.627c-2.061-2.544-3.811-4.704-3.891-4.797l-0.147-0.17-0.909 1.123zM12.112 7.53l-0.912 1.123 0.202 0.25 2.944 3.651c1.51 1.869 2.749 3.421 2.749 3.446s-1.238 1.578-2.749 3.446l-3.146 3.901 0.912 1.123 0.909 1.123 0.147-0.17c0.080-0.093 1.83-2.253 3.891-4.797l3.744-4.627-3.744-4.627c-2.061-2.544-3.811-4.704-3.891-4.797l-0.147-0.17-0.909 1.123zM21.712 7.53l-0.912 1.123 0.202 0.25 2.944 3.651c1.51 1.869 2.749 3.421 2.749 3.446s-1.238 1.578-2.749 3.446l-3.146 3.901 0.912 1.123 0.909 1.123 0.147-0.17c0.080-0.093 1.83-2.253 3.891-4.797l3.744-4.627-3.744-4.627c-2.061-2.544-3.811-4.704-3.891-4.797l-0.147-0.17-0.909 1.123z" />
    </SvgIcon>
  );
});

Active.displayName = "Active";

export default Active;
